import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcBillingInfoSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.66667 5.66666C4.64162 5.66666 3 7.30828 3 9.33332V22.6667C3 24.6917 4.64162 26.3333 6.66667 26.3333H25.3333C27.3584 26.3333 29 24.6917 29 22.6667V9.33332C29 7.30828 27.3584 5.66666 25.3333 5.66666H6.66667ZM5 22.6667V13H27V22.6667C27 23.5871 26.2538 24.3333 25.3333 24.3333H6.66667C5.74619 24.3333 5 23.5871 5 22.6667ZM5 11H27V9.33332C27 8.41285 26.2538 7.66666 25.3333 7.66666H6.66667C5.74619 7.66666 5 8.41285 5 9.33332V11ZM9.33333 16.3333C8.78105 16.3333 8.33333 16.781 8.33333 17.3333C8.33333 17.8856 8.78105 18.3333 9.33333 18.3333H13.3333C13.8856 18.3333 14.3333 17.8856 14.3333 17.3333C14.3333 16.781 13.8856 16.3333 13.3333 16.3333H9.33333Z",
		fill: "#091F24"
	})
});
export default SvgIcBillingInfoSmallOl;
